module.exports = __webpack_public_path__ + "static/media/ic-warning.061d2a04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-warning.svg
// module id = 681
// module chunks = 14